import Modal from 'antd/es/modal';
import { styled } from 'styled-components';

export const StyledModal = styled(Modal)`
  .ant-modal-header {
    margin-bottom: 0;
  }
  .ant-modal-content {
    overflow-y: auto;
  }
`;

export const StepsContainer = styled.div`
  ${({ theme }) => `
  padding: ${theme.paddingLG}px 0;
  border-bottom: 1px solid ${theme.colorBorderSecondary};
`}
`;

export const ContentContainer = styled.div`
  ${({ theme }) => `
  padding: ${theme.paddingLG}px 0;
  margin-bottom: ${theme.marginXXL}px;
  max-height: ${theme.controlHeightLG + 5}dvh;
  overflow-y: auto;
`}
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
